const SkeletonCard = () => {
  return (
    <>
      <div className='h-64 w-full rounded-xl bg-gray-200 animate-pulse mb-5'></div>
    </>
  )
}

export default SkeletonCard
